import { useCreateOperator } from '../../../../../../contexts/CreateOperatorContext';
import { DynamicForm } from '../../../DynamicForm';
import { SettingItemList } from '../../../SettingItemList';
import { ExperienceGroup } from './ExperienceGroup';
import { ViewQuilt } from '@material-ui/icons';
import { CsvImportButton } from '../../../../CsvImportButton';
import { CollapsableContent } from '../../../../../../components/CollapsableContent/CollapsableContent';
import React from 'react';

export const ExperienceGroups = () => {
  const { operator, updateOperator } = useCreateOperator();
  const classes = useStyles();

  if (operator.mediaFirstSettings === undefined) return null;

  const handleRemovePkg = (egIndex: number) => {
    updateOperator(
      'mediaFirstSettings',
      Object.assign(operator.mediaFirstSettings!, {
        experienceGroups: (
          operator.mediaFirstSettings?.experienceGroups ?? []
        ).filter((value, index) => index !== egIndex),
      })
    );
  };

  const handleSavePkg = (item: CreateExperienceGroup, egIndex: number) => {
    updateOperator(
      'mediaFirstSettings',
      Object.assign(operator.mediaFirstSettings!, {
        experienceGroups: (
          operator.mediaFirstSettings?.experienceGroups ?? []
        ).map((value, index) => {
          if (index === egIndex) return item;
          return value;
        }),
      })
    );
  };

  return (
    <CollapsableContent
      icon={<ViewQuilt />}
      header={<p>Experience Groups</p>}
      count={(operator.mediaFirstSettings?.experienceGroups ?? []).length}
      customAction={
        <CsvImportButton
          canOverwrite={true}
          settingName="Experience Groups"
          requiredColumns={[
            { name: 'description', type: 'string' },
            { name: 'mediafirstId', type: 'string' },
          ]}
          onImport={(csv, overwrite) =>
            updateOperator(
              'mediaFirstSettings',
              Object.assign(operator.mediaFirstSettings!, {
                experienceGroups: overwrite
                  ? csv
                  : [
                      ...csv,
                      ...(operator.mediaFirstSettings?.experienceGroups ?? []),
                    ],
              })
            )
          }
        />
      }
      padding="sm"
    >
      <div className={classes.container}>
        <DynamicForm<CreateExperienceGroup>
          defaultForm={{
            active: true,
            description: '',
            mediafirstId: '',
          }}
          inputs={[
            {
              order: 0,
              rowInputs: [
                {
                  props: {
                    name: 'description',
                    label: 'Description',
                    required: false,
                    value: (values) => values.description,
                  },
                },
                {
                  props: {
                    name: 'mediafirstId',
                    label: 'MediaFirst ID',
                    required: false,
                    value: (values) => values.mediafirstId,
                  },
                },
              ],
            },
          ]}
          submitButton={{ text: 'Add Experience Group' }}
          validation={(values) =>
            (values.description ?? '').trim() !== '' &&
            (values.mediafirstId ?? '').trim() !== ''
          }
          onSubmit={(values) =>
            updateOperator(
              'mediaFirstSettings',
              Object.assign(operator.mediaFirstSettings!, {
                experienceGroups: [
                  values,
                  ...(operator.mediaFirstSettings?.experienceGroups ?? []),
                ],
              })
            )
          }
        />
        <SettingItemList<CreateExperienceGroup>
          name="Experience Groups"
          items={operator.mediaFirstSettings?.experienceGroups ?? []}
          renderRow={(item, index) => (
            <ExperienceGroup
              index={index}
              experienceGroup={item}
              onRemove={handleRemovePkg}
              onSave={handleSavePkg}
            />
          )}
        />
      </div>
    </CollapsableContent>
  );
};

const useStyles = () => ({
  container: 'flex flex-col gap-4 items-center w-full',
  inputs: 'inline-flex items-center gap-4',
});
